import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table'
import Moment from 'react-moment';

export default function Users(props) {

    const [users, setUsers] = useState([])

    useEffect(() => {

        fetch('https://playattitude.fr/admin/users/all', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            })
        }).then(res => res.json())
            .then(res => {
                setUsers(res)
            })
    }, [])

    return (
        <div>
            <h2>Utilsateurs</h2>
            <MaterialTable
                columns={[
                    { title: 'Email', field: 'email' },
                    { title: 'Nom', field: 'name' },
                    { title: 'Prénom', field: 'surname' },
                    { title: 'Niveau', field: 'level' }

                ]}
                data={users}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Voir le détail',
                        onClick: (event, rowData) =>  props.history.push("/user/" + rowData.id)
                    }
                ]}
                options={{
                    actionsColumnIndex: -1,
                    exportButton: true

                }}
                title="Les utilisateurs"
            />
        </div>
    );
}